import { axios } from 'Lib/axios'
import { useQueries, UseQueryOptions } from '@tanstack/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { AccountSettings } from 'Types/AccountSettings'
import { CreditCard } from 'Types/CreditCard'

const getAccountSettings = (accountId: number): Promise<AccountSettings> | Error => {
  try {
    return axios
      .get<{ data: AccountSettings }>(`accounts/${accountId}/setup`)
      .then((res) => res.data.data)
  } catch (e) {
    return e as Error
  }
}

const getCreditCard = (accountId: number): Promise<CreditCard> | Error => {
  try {
    return axios
      .get<{ data: CreditCard }>(`accounts/${accountId}/setup/card`)
      .then((res) => res.data.data)
  } catch (e) {
    return e as Error
  }
}

export const useGetAccountSettings = () => {
  const { accountId, subscriptionId, owner } = useUserStore()

  return useQueries({
    queries: [
      {
        enabled: accountId > 0 && !!subscriptionId && owner,
        queryKey: ['accountSettings'],
        queryFn: () => getAccountSettings(accountId),
      } as UseQueryOptions<AccountSettings | Error>,

      {
        queryKey: ['creditCard'],
        enabled: accountId > 0 && !!subscriptionId && owner,
        queryFn: () => getCreditCard(accountId),
      } as UseQueryOptions<CreditCard | Error>,
    ],
  })
}
